import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const sendNotificationPreview = async (domain: string, flowId: number, notificationId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/templates-preview/${notificationId}`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain
    });
}